// extracted by mini-css-extract-plugin
export default {"bgWhite":"_1TkXHpyaSYXQQJIp3ucKXp","site_layout_background":"_3U7weET6hLwlLAf3qUvhnC","siteLayoutBackground":"_3U7weET6hLwlLAf3qUvhnC","tableRowClass":"gQNqZz-ZhQfLMmNerrlOr"};